module.exports = __webpack_public_path__ + "static/quiz_finish_score_title_bg-ab2f45c5f9f9bfa525e07a8107274e87.svg";